import { useTranslation } from 'react-i18next';

import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import useResponsive from '~/hooks/useResponsive';

import { DeleteApiKeyViewProps } from '../../utils/types';
import ModalHeader from './ModalHeader';

const DeleteApiKeyView = ({
  keyName,
  onConfirm,
  onCancel,
  onClose,
  isDeleting = false,
}: DeleteApiKeyViewProps) => {
  const { t } = useTranslation('aiTooling', {
    keyPrefix: 'apiKeys.modal.delete',
  });
  const { isMobile } = useResponsive();
  const isMobileView = isMobile();

  return (
    <>
      <ModalHeader title={t('title')} onClose={onClose} />
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">
            {t('confirm', { name: keyName })}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ whiteSpace: 'pre-line' }}
          >
            {t('detail')}
          </Typography>
          <Stack
            direction={isMobileView ? 'column' : 'row'}
            spacing={1}
            justifyContent="flex-end"
          >
            <Button
              variant="text"
              onClick={onCancel}
              data-testid="delete-api-key-cancel-btn"
              fullWidth={isMobileView}
              disabled={isDeleting}
            >
              {t('cancel')}
            </Button>
            <LoadingButton
              loading={isDeleting}
              variant="contained"
              onClick={onConfirm}
              disabled={isDeleting}
              data-testid="delete-api-key-confirm-btn"
              fullWidth={isMobileView}
            >
              {t('delete')}
            </LoadingButton>
          </Stack>
        </Stack>
      </DialogContent>
    </>
  );
};

export default DeleteApiKeyView;
